// extracted by mini-css-extract-plugin
module.exports = {"layout":"F9zx","topBlock":"F9zz","content":"F9bd","leftCol":"F9j","centralCol":"F9z1","infinityFeedRsya":"F9z3","footer":"F9f7"};